import { TFunction } from 'i18next'
import { ItemState } from '../models'

export type MailtoParams = {
  subject: string
  body: string
}

export type ListedItemShareMailtoParams = {
  listedItemId: number | string
  name: string
  nonprofitName?: string
  senderName?: string
}

/** Public URL for a listed item detail page (current origin + optional `PUBLIC_URL` base). */
export function getListedItemPublicUrl(itemId: number | string): string {
  const pathBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  const path = `${pathBase}/listed-items/${itemId}`
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`
  }
  return path
}

export function buildMailtoHref({ subject, body }: MailtoParams): string {
  const query = [
    `subject=${encodeURIComponent(subject)}`,
    `body=${encodeURIComponent(body)}`,
  ].join('&')

  return `mailto:?${query}`
}

export function canShareListedItemByEmail(
  loading: boolean,
  state: ItemState | undefined,
  listedItemId?: number | string,
  name?: string
): boolean {
  return (
    !loading &&
    listedItemId != null &&
    !!name &&
    (state === ItemState.Active || state === ItemState.Sold)
  )
}

export function buildListedItemShareMailtoHref(
  t: TFunction,
  params: ListedItemShareMailtoParams | undefined
): string | undefined {
  if (!params?.listedItemId || !params.name) {
    return undefined
  }

  const url = getListedItemPublicUrl(params.listedItemId)
  const nonprofitName = params.nonprofitName?.trim() || 'a nonprofit'
  const itemTitle = params.name.trim()
  const senderName = params.senderName?.trim() || 'A Prosphora supporter'

  return buildMailtoHref({
    subject: t('itemDetails.shareByEmail.subject', { nonprofitName }),
    body: t('itemDetails.shareByEmail.body', {
      itemTitle,
      nonprofitName,
      url,
      senderName,
    }),
  })
}
